
$(document).ready(function(){
  $('.su-spoiler-title').click(function(){
    $('.su-spoiler-content').slideToggle();
    if ($(this).text() === '+ More') {
      $(this).text('- More');
    } else {
      $(this).text('+ More');
    }
  });
});


// installation value

$(document).ready(function() {
  $('#line-item-property__fieldInstallation').change(function() {
    var selectedValue = $(this).val();
    
    $('input[name="properties[Installation / Fitting Required *]"]').each(function() {
      if ($(this).val() == selectedValue) {
        $(this).prop('checked', true);
      } else {
        $(this).prop('checked', false);
      }
    });
  });

});


  const myTimeout = setTimeout(myGreeting, 5000);

function myGreeting(){
  document.getElementById('45852-text-2').setAttribute('type','date')
  document.getElementById('45852-text-3').setAttribute('type','date')
}
